export default function (block) {}
